<script setup lang="ts">
/**
 * Renderless helper that mirrors a slot-scoped reactive value into a
 * `dirty`/`update` ref-pair the parent's setup() can read.
 *
 * Specifically: VeeValidate's `<Form v-slot="{ meta }">` exposes
 * `meta.dirty` only inside the slot. Editors host their discard guard
 * (which needs to know dirty) outside that slot. This component bridges
 * the gap by emitting whenever the bool flips, so the parent keeps a
 * local ref it can read from any setup context.
 *
 * Usage:
 *   <FormDirtyBridge :dirty="meta.dirty" @update="(v) => (formDirty = v)" />
 */
import { watch } from 'vue'

const props = defineProps<{ dirty: boolean }>()
const emit = defineEmits<{ update: [dirty: boolean] }>()

watch(
  () => props.dirty,
  (v) => emit('update', v),
  { immediate: true },
)
</script>

<template>
  <span class="sr-only" aria-hidden="true" />
</template>
